import { faLink } from '@fortawesome/pro-light-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

export interface ShareDropdownProps {
  shareDropdownRef: React.RefObject<HTMLUListElement | null>;
  isCopied: boolean;
  setIsCopied: (isCopied: boolean) => void;
  articleURL: string;
  title: string;
}

const ShareDropdown = ({
  shareDropdownRef,
  isCopied,
  setIsCopied,
  articleURL,
}: ShareDropdownProps) => {
  const copyTextClasses = clsx(
    'text-sm font-normal not-italic text-gray-900 hover:underline sm:text-base sm:leading-[20px]',
    {
      'text-success-800': isCopied,
    }
  );

  return (
    <ul
      ref={shareDropdownRef}
      className='absolute left-0 top-6 z-50 flex w-36 flex-col items-start justify-center divide-y rounded-lg bg-white shadow-[rgba(0,0,0,0.35)_0px_5px_15px] sm:top-8 sm:w-36'
      onClick={(e) => e.stopPropagation()}
    >
      <li
        onClick={async () => {
          try {
            await navigator.clipboard.writeText(articleURL);
            setIsCopied(true);
          } catch {
            /* No need to do anything */
          }
        }}
        className='w-full'
      >
        <a
          className='flex w-full items-center gap-2 p-3 hover:cursor-pointer'
          data-behavior='copy_link'
          data-social-tool='copy'
          data-social-type='content'
          aria-label='Copy Link'
        >
          <div className='flex w-6 items-center justify-center'>
            <FontAwesomeIcon icon={faLink} />
          </div>
          <span className={copyTextClasses}>{isCopied ? 'Copied!' : 'Copy Link'}</span>
          {isCopied ? (
            <div className='flex w-6 items-center justify-center text-success-800'>
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
          ) : null}
        </a>
      </li>
      {/*
      <li className="w-full">
        <a
          className="flex w-full items-center gap-2 p-3 hover:cursor-pointer"
          data-social-tool="email"
          href={`mailto:?subject=${title}&body=${articleURL}`}
          data-social-type="content"
          aria-label="Email"
        >
          <div className="flex w-6 items-center justify-center">
            <FontAwesomeIcon icon={faEnvelope} />
          </div>
          <span className="text-sm font-normal not-italic text-gray-900 sm:text-base sm:leading-[20px]">Email</span>
        </a>
      </li>
      */}
    </ul>
  );
};

export default ShareDropdown;
